import * as React from 'react';
import classNames from 'classnames';

import * as Classes from '../common/classes';

import { SelectBox } from '../selectbox/SelectBox';

import type { SelectBoxProps } from '../selectbox/SelectBox';

interface Color {
  id: string;
  name: string;
}

export type ColorSelectProps = Omit<
  SelectBoxProps<Color, string>,
  'items' | 'colors' | 'useIdAsValue'
>;

const BASE_COLORS: Color[] = [
  { id: '#CD5C5C', name: 'Indian Red' },
  { id: '#DC143C', name: 'Crimson' },
  { id: '#8B0000', name: 'Dark Red' },
  { id: '#C71585', name: 'Medium Violet Red' },
  { id: '#FF6347', name: 'Tomato' },
  { id: '#FF4500', name: 'Orange Red' },
  { id: '#FFD700', name: 'Gold' },
  { id: '#BDB76B', name: 'Dark Khaki' },
  { id: '#FF00FF', name: 'Magenta' },
  { id: '#BA55D3', name: 'Medium Orchid' },
  { id: '#8A2BE2', name: 'Blue Violet' },
  { id: '#4B0082', name: 'Indigo' },
  { id: '#483D8B', name: 'Dark Slate Blue' },
  { id: '#006400', name: 'Dark Green' },
  { id: '#808000', name: 'Olive' },
  { id: '#20B2AA', name: 'Light Sea Green' },
  { id: '#008080', name: 'Teal' },
  { id: '#4682B4', name: 'Steel Blue' },
  { id: '#4169E1', name: 'Royal Blue' },
  { id: '#000080', name: 'Navy' },
  { id: '#DAA520', name: 'Goldenrod' },
  { id: '#DAA520', name: 'Saddle Brown' },
  { id: '#800000', name: 'Maroon' },
  { id: '#708090', name: 'Slate Gray' },
  { id: '#000000', name: 'Black' },
];

export const ColorSelect: React.FC<ColorSelectProps> = ({
  onChange: baseOnChange,
  dataTest,
  ...restProps
}) => {
  const currentColor = React.useRef<string | undefined>(
    restProps.value ?? undefined
  );
  const onChange = (val?: string | undefined) => {
    if (baseOnChange) baseOnChange(val);
    currentColor.current = val ?? undefined;
  };

  const wrapperClassName = classNames(Classes.COLOR_SELECT_WRAPPER, {
    [`${Classes.COLOR_SELECT_WRAPPER}--has-value`]: !!currentColor.current,
    [`${Classes.COLOR_SELECT_WRAPPER}--disabled`]: !!restProps.disabled,
  });
  const selectBoxClassname = classNames(Classes.COLOR_SELECT);
  const currentColorClassname = classNames(Classes.COLOR_SELECT_CURRENT_COLOR);

  return (
    <div className={wrapperClassName}>
      {currentColor.current ? (
        <div
          className={currentColorClassname}
          style={{ backgroundColor: currentColor?.current }}
        />
      ) : null}
      <SelectBox
        dataTest={dataTest}
        className={selectBoxClassname}
        items={BASE_COLORS}
        // @ts-ignore
        onChange={onChange}
        colors
        useIdAsValue
        {...restProps}
      />
    </div>
  );
};
